/* eslint-disable no-shadow */
import React, { Component } from "react";
// import ErrorBoundary from "../../shared/error/ErrorBoundary";
// import FullScreenLoading from "../../shared/loaders/FullScreenLoading";ytd
// import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
import {
  analyticsFilter,
  resetDefaultFilters,
  resetDateRangeFilter,
} from "../../../actions/employerAnalyticsActions";
import { connect } from "react-redux";
import FilterAndSort from "./FilterAndSort";
export interface IFilterMainProps {
  loading: boolean;
  filters: object;
  filterAction: any;
  analyticsFilter: (
    data?: object,
    action?: any,
    dispatching?: boolean,
    selectedFilters?: object
  ) => void;
  resetDefaultFilters: (isFirstRun: boolean) => void;
  resetDateRangeFilter: () => void;
}

export class FilterMain extends Component<IFilterMainProps> {
  componentDidMount(): void {
    const { analyticsFilter } = this.props;
    analyticsFilter();
  }
  render(): React.ReactNode {
    const {
      filters,
      filterAction,
      analyticsFilter,
      resetDefaultFilters,
      resetDateRangeFilter,
    } = this.props;
    return (
      <div style={{ display: "flex" }}>
        <FilterAndSort
          filters={filters}
          filterAction={filterAction}
          analyticsFilter={analyticsFilter}
          resetDefaultFilters={resetDefaultFilters}
          resetDateRangeFilter={resetDateRangeFilter}
        ></FilterAndSort>
      </div>
    );
  }
}
interface IReduxState {
  employerAnalytics: {
    filtersLoading: boolean;
    filtersData: {
      filters: object;
      filterAction: string;
    };
    resetDefaultFilters: object;
  };
}
const mapStateToProps = (state: IReduxState) => ({
  filters: state.employerAnalytics?.filtersData?.filters,
  filterAction: state.employerAnalytics?.filtersData?.filterAction,
  loading: state.employerAnalytics?.filtersLoading,
  isFirstRun: state.employerAnalytics?.resetDefaultFilters,
});
export default connect(mapStateToProps, {
  analyticsFilter,
  resetDefaultFilters,
  resetDateRangeFilter,
})(FilterMain);
